import React from 'react';
import { useTranslation } from 'react-i18next';
import { GovSkeleton } from '@gov-design-system-ce/react';
import { LocalizeNameSpaceTypes } from '@gov-nx/core/service';
import { LayoutGap } from '@gov-nx/ui/web';
import {
	generateRandomNumber,
	generateArrayFromLength,
} from '@gov-nx/utils/common';

export const EPetitionSkeleton = () => {
	const { t } = useTranslation(LocalizeNameSpaceTypes.Global);
	return (
		<>
			<LayoutGap>
				{/* filter + badges */}
				<div className="flex justify-between">
					<div className="w-60 [ md:w-80 ]">
						<GovSkeleton
							width="100%"
							height="40px"
							aria-label={t('loading.wcag.processing', {
								namespace: LocalizeNameSpaceTypes.Global,
							})}
						/>
					</div>
					<GovSkeleton
						width="40px"
						height="40px"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
				</div>
				<div className="flex gap-4 mb-8">
					<GovSkeleton
						width="60px"
						height="40px"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
					<GovSkeleton
						width="110px"
						height="40px"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
					<GovSkeleton
						width="110px"
						height="40px"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
				</div>
			</LayoutGap>
			<EPetitionListSkeleton />
		</>
	);
};

export const EPetitionListSkeleton = () => {
	const { t } = useTranslation(LocalizeNameSpaceTypes.Global);
	return (
		<div>
			{generateArrayFromLength(5).map((i) => (
				<LayoutGap
					gap="s"
					className="p-6 border-b border-(--border-subtlest)"
					key={i}>
					<GovSkeleton
						width={generateRandomNumber(20, 60) + '%'}
						height="26px"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
					<GovSkeleton
						width="95px"
						height="30px"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
					<GovSkeleton
						width="75%"
						height="22px"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
					<GovSkeleton
						width={generateRandomNumber(80, 100) + '%'}
						height="22px"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
					<GovSkeleton
						width={generateRandomNumber(40, 100) + '%'}
						height="22px"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
				</LayoutGap>
			))}
		</div>
	);
};
